import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './components/App/App';
import GlobalStyle from './styles/GlobalStyles';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/config/theme';
import { ModalProvider } from './core/context/ModalContext';
import { HomeProvider } from './core/context/HomeContext';
import { ExploreProvider } from './core/context/ExploreContext';
import { LifestyleProvider } from './core/context/LifestyleContext';
import { MentalHealthProvider } from './core/context/MentalHealthContext';
import { SupportProvider } from './core/context/SupportContext';
import { SleepProvider } from './core/context/SleepContext';
import { MyJaaqProvider } from './core/context/MyJaaqContext';
import { FooterProvider } from './core/context/FooterContext';
import { ExperienceSleepProvider } from './core/context/ExperienceSleepContext';
import { LearningDifferenciesProvider } from './core/context/LearningDifferenciesContext';
import { WellbeingProvider } from './core/context/WellbeingContext';
import { TherapyProvider } from './core/context/TherapyContext';
import { WorkplaceProvider } from './core/context/WorkplaceContext';
import { DiversityProvider } from './core/context/DiversityContext';
import { MenWomenHealthProvider } from './core/context/MenWomenHealthContext';
import { ExperienceYogaProvider } from './core/context/ExperienceYogaContext';
import { YogaProvider } from './core/context/YogaContext';
import { DepressionProvider } from './core/context/DepressionContext';
import { ExperienceDepressionProvider } from './core/context/ExperienceDepressionContext';

ReactDOM.render(
  <React.StrictMode>
    <ModalProvider>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <HomeProvider>
          <ExploreProvider>
            <LifestyleProvider>
              <MentalHealthProvider>
                <SupportProvider>
                  <SleepProvider>
                    <MyJaaqProvider>
                      <FooterProvider>
                        <ExperienceSleepProvider>
                          <LearningDifferenciesProvider>
                            <WellbeingProvider>
                              <TherapyProvider>
                                <WorkplaceProvider>
                                  <DiversityProvider>
                                    <MenWomenHealthProvider>
                                      <YogaProvider>
                                        <ExperienceYogaProvider>
                                          <DepressionProvider>
                                            <ExperienceDepressionProvider>
                                              <GlobalStyle />
                                              <Router>
                                                <App />
                                              </Router>
                                            </ExperienceDepressionProvider>
                                          </DepressionProvider>
                                        </ExperienceYogaProvider>
                                      </YogaProvider>
                                    </MenWomenHealthProvider>
                                  </DiversityProvider>
                                </WorkplaceProvider>
                              </TherapyProvider>
                            </WellbeingProvider>
                          </LearningDifferenciesProvider>
                        </ExperienceSleepProvider>
                      </FooterProvider>
                    </MyJaaqProvider>
                  </SleepProvider>
                </SupportProvider>
              </MentalHealthProvider>
            </LifestyleProvider>
          </ExploreProvider>
        </HomeProvider>
      </ThemeProvider>
    </ModalProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
